import React, { Component } from 'react';
import { connect } from 'react-redux';
import { userActions } from '../../_actions';
import LoadingOverlay from 'react-loading-overlay';
import ReactPaginate from 'react-paginate';
import DialogExample from "./components/DialogExample/DialogExample";
import ViewMoreDetailsModal from "./components/ViewMoreDetailsModal/ViewMoreDetailsModal";
import AddBalanceModal from './components/AddBalanceModal/AddBalanceModal';
import AddPtSessionModal from './components/AddPtSessionModal/AddPtSessionModal';
import DeductBalanceModal from './components/AddBalanceModal/DeductBalanceModal';
import AddUserModal from "./components/AddUserModal";
import UpdateUserModal from "./components/UpdateUserModal";
import { isMobile } from "react-device-detect";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import UpdateUserPasswordModal from './components/UpdateUserPasswordModal/UpdateUserPasswordModal';
import { BiSearch } from "react-icons/bi";
import { RiLockPasswordLine, RiWalletLine } from "react-icons/ri";
import { MdAdd } from "react-icons/md";
import { BiDetail } from "react-icons/bi";
import { MdOutlineEdit, MdOutlineAccountBalanceWallet } from "react-icons/md";
import './style.css'
import { BiArrowBack } from "react-icons/bi";


class User extends Component {
  constructor(props) {
    super(props);
    this.handleHover = this.handleHover.bind(this);
    this.state = {
      scale: 1,
      hover: false,
      isVideo: false,
      isVideoUpdate: false,
      userRowData: {},
      fieldsUser: {},
      errorsUser: {},
      fieldsUserUpdate: {},
      fieldsUserPasswordUpdate: {},
      errorsUserUpdate: {},
      errorsUpdatePassword: {},
      viewRowData: {},
      type: null,
      gameType: null,
      rankType: null,
      addQuoteModal: false,
      moreDetailsCreateModal: false,
      UpdateUserModal: false,
      loginToThisAccountModal: false,
      addUserModal: false,
      creditpasswordOpenModal: false,
      errorsUpdate: {},
      AddBalanceModal: false,
      DeductBalanceModal: false,
      AddPtSession: false,
      AddPtSessionModel: false,
      balance: '',
      offset: 0,
      size: 10,
      pageNo: 1,
      keyWord: '',
      updatePwdformData: {
        "id": "",
        "password": ""
      }
    }
  }
  componentDidMount() {
    let reqData = {
      "keyWord": this.state.keyWord,
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }
    this.props.dispatch(userActions.getUserList(reqData));

    // let data = {
    //   "userId": this.props.match.params.id
    // }
    // this.props.dispatch(userActions.createSport(data));
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.users.addUserSuccess) {
      return {
        ...nextProps,
        fieldsUserUpdate: {},
        fieldsUser: {},
        fieldsUserPasswordUpdate: {},
        errorsUserUpdate: {},
        errorsUpdatePassword: {},
        UpdateUserModal: false,
        creditpasswordOpenModal: false,
        addUserModal: false,
        addQuoteModal: false,
        // fieldsUser: {},
        errorsUpdateQuoteAdd: {},
        errorsUpdate: {},
        AddBalanceModal: false,
        AddPtSessionModel: false,
        // addQuoteModal: false,
        DeductBalanceModal: false,
        balance: '',
        idParam: '',
        fieldsUserdeduct: ''

      }
    } else {
      return {
        ...nextProps,

      }
    }
  }

  handlePageClick = (data) => {
    // console.log("data  ", data);
    let offset = Math.ceil(data.selected * this.state.size);
    this.setState({ offset: offset, page: data.selected });
    let datatemp = {
      "keyWord": this.state.keyWord,
      "pageNo": data.selected + 1,
      "size": this.state.size
    }
    this.props.dispatch(userActions.getUserList(datatemp));
  }
  handleSearch = (event) => {
    event.preventDefault();
    let { value } = event.target;
    this.setState({ keyWord: value, offset: 0 });
    let data = {
      "keyWord": value,
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }
    this.props.dispatch(userActions.getUserList(data));
  }

  disableUser = (data) => {
    let datatemp = {
      "id": data._id,
    }
    let paginationdata = {
      "keyWord": "",
      "pageNo": 1,
      "size": this.state.size
    }
    confirmAlert({
      title: 'Confirm to disable User?',
      message: `Are you sure to disables ${data.name}?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.props.dispatch(userActions.disableUser(datatemp, paginationdata))
        },
        {
          label: 'No'
        }
      ]
    });
  }

  deleteUser = (data) => {
    let datatemp = {
      "id": data.id,
    }
    let paginationData = {
      "keyWord": this.state.keyWord,
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }

    confirmAlert({

      title: 'Confirm to Delete?',
      message: `Are you sure to delete ${data.name}?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.props.dispatch(userActions.deleteUser(datatemp, paginationData))
        },
        {
          label: 'No'
        }
      ]
    });
  }

  handleOpenCreateModalMoreDetails = (data) => {
    this.props.history.push("/app/moreDetails/" + data.id)
  }

  handleMoreDetailsHideModal = () => {
    this.setState({ moreDetailsCreateModal: false });
  }


  handleUpdateUserModalClose = () => {
    this.setState({ UpdateUserModal: false });
  }

  handleloginToThisAccountHideModal = () => {
    this.setState({ loginToThisAccountModal: false });
  }
  handleOpenloginToThisAccountModal = (data) => {
    // // console.log("data loginToThisAccountloginToThisAccountloginToThisAccount....", data);
    let req = {
      "id": data.id
    }
    this.props.dispatch(userActions.loginToThisAccount(req));
    this.setState({ loginToThisAccountModal: true });
  }
  handleAddUserHideModal = () => {
    this.setState({ addQuoteModal: false });
    // this.setState({ appsettingUpdateModal: false });
  }

  handleOpenCreateModal = () => {
    // // console.log("clicked");
    this.setState({ addQuoteModal: true });
  }
  inputAddUserChange = (e) => {
    console.log(e.target.name, 'e___________________________', e.target.value);
    e.preventDefault();
    let { name, value } = e.target;
    let fieldsUser = this.state.fieldsUser;
    let errorsUser = this.state.errorsUser;
    fieldsUser[name] = value;
    // console.log(name, value);
    errorsUser[name] = "";
    this.setState({ fieldsUser, errorsUser });
  }
  inputChangeUpdateUser = (e) => {
    e.preventDefault();
    let { name, value } = e.target;
    let fieldsUserUpdate = this.state.fieldsUserUpdate;
    let errorsUserUpdate = this.state.errorsUserUpdate;
    fieldsUserUpdate[name] = value;
    errorsUserUpdate[name] = "";
    // console.log(name, value);
    this.setState({ fieldsUserUpdate, errorsUserUpdate });
  }
  inputChangeUpdatePasswordUser = (e) => {
    e.preventDefault();
    // console.log("1111111111111", e.target.value);
    let { name, value } = e.target;
    let fieldsUserPasswordUpdate = this.state.fieldsUserPasswordUpdate;
    let errorsUpdatePassword = this.state.errorsUpdatePassword;
    fieldsUserPasswordUpdate[name] = value;
    errorsUpdatePassword[name] = "";
    // console.log(name, value);
    this.setState({ fieldsUserPasswordUpdate, errorsUpdatePassword });
  }


  createAddUserSubmit = () => {
    // let { users } = this.props;
    // let { filesDetails } = users;
    if (this.handleValidationAddUser()) {
      // console.log('111111111111111111111');
      let reqData = {
        "userName": this.state.fieldsUser.userName,
        "name": this.state.fieldsUser.name,
        "email": this.state.fieldsUser.email,
        "mobNo": this.state.fieldsUser.mobNo,
        "password": this.state.fieldsUser.password,
      }

      let pagination = {
        "keyWord": this.state.keyWord,
        "pageNo": this.state.pageNo,
        "size": this.state.size
      }

      // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>", reqData);
      this.props.dispatch(userActions.createNewUser(reqData, pagination));
    }

  }
  handleFile = (event) => {
    // console.log("handleFileevent", event);

    this.setState({ selectedFile: event.target.files[0] });

    if (event.target.files[0]) {
      this.setState({ selectedFile: null });
      this.props.dispatch(userActions.uploadImage(event.target.files[event.target.files.length - 1]));

    }
    else {
      // console.log("No File To Upload!")
    }

  }

  handleValidationAddUser = () => {
    let fieldsUser = this.state.fieldsUser;
    let errorsUser = {};
    let formIsValid = true;

    //userName
    if (!fieldsUser["userName"] || fieldsUser["userName"] === "") {
      formIsValid = false;
      errorsUser["userName"] = "Cannot be empty";
    }
    //name
    if (!fieldsUser["name"] || fieldsUser["name"] === "") {
      formIsValid = false;
      errorsUser["name"] = "Cannot be empty";
    }
    //Email
    if (!fieldsUser["email"] || fieldsUser["email"] === "") {
      formIsValid = false;
      errorsUser["email"] = "Please Enter Email Address";
    }
    if (typeof fieldsUser["email"] !== "undefined" && fieldsUser["email"] !== "") {
      let lastAtPos = fieldsUser["email"].lastIndexOf('@');
      let lastDotPos = fieldsUser["email"].lastIndexOf('.');

      if (!(lastAtPos < lastDotPos && lastAtPos > 0 && fieldsUser["email"].indexOf('@@') === -1 && lastDotPos > 2 && (fieldsUser["email"].length - lastDotPos) > 2)) {
        formIsValid = false;
        errorsUser["email"] = "Enter valid email!";
      }
    }
    //phoneNumber
    if (!fieldsUser["mobNo"] || fieldsUser["mobNo"] === "") {
      formIsValid = false;
      errorsUser["mobNo"] = "Cannot be empty";
    }

    // console.log('errorsUpdateQuoteerrorsUpdateQuoteerrorsUpdateQuote', errorsUser);
    this.setState({ errorsUser: errorsUser });
    return formIsValid;
  }

  updateUserSubmit = () => {
    // let { users } = this.props;
    // let { filesDetails } = users;

    if (this.handleValidationUpdateUser()) {
      let reqData = {
        "userId": this.state.fieldsUserUpdate._id,
        "name": this.state.fieldsUserUpdate.name,
        "email": this.state.fieldsUserUpdate.email,
        "mobNo": this.state.fieldsUserUpdate.mobNo,
      }
      let paginationData = {
        "keyWord": this.state.keyWord,
        "pageNo": this.state.pageNo,
        "size": this.state.size
      }
      // console.log("update>>>>>>>>>>>>>>>>>>>>>>>", reqData);
      this.props.dispatch(userActions.updateUser(reqData, paginationData));
    }

  }

  updateUserPasswordSubmit = () => {
    if (this.handleValidationUpdateUserPassword()) {
      let reqData = {
        "userId": this.state.fieldsUserPasswordUpdate._id,
        "newpassword": this.state.fieldsUserPasswordUpdate.newpassword,
        "confirmnewpassword": this.state.fieldsUserPasswordUpdate.confirmnewpassword,
      }

      let paginationData = {
        "keyWord": this.state.keyWord,
        "pageNo": this.state.pageNo,
        "size": this.state.size
      }

      this.props.dispatch(userActions.updateUserpassword(reqData, paginationData));
    }

  }
  handleValidationUpdateUser = () => {
    let fieldsUserUpdate = this.state.fieldsUserUpdate;
    let errorsUserUpdate = {};
    let formIsValid = true;

    //name
    if (!fieldsUserUpdate["name"] || fieldsUserUpdate["name"] === "") {
      formIsValid = false;
      errorsUserUpdate["name"] = "Cannot be empty";
    }
    //Email
    if (!fieldsUserUpdate["email"] || fieldsUserUpdate["email"] === "") {
      formIsValid = false;
      errorsUserUpdate["email"] = "Please Enter Email Address";
    }
    if (typeof fieldsUserUpdate["email"] !== "undefined" && fieldsUserUpdate["email"] !== "") {
      let lastAtPos = fieldsUserUpdate["email"].lastIndexOf('@');
      let lastDotPos = fieldsUserUpdate["email"].lastIndexOf('.');

      if (!(lastAtPos < lastDotPos && lastAtPos > 0 && fieldsUserUpdate["email"].indexOf('@@') === -1 && lastDotPos > 2 && (fieldsUserUpdate["email"].length - lastDotPos) > 2)) {
        formIsValid = false;
        errorsUserUpdate["email"] = "Enter valid email!";
      }
    }
    //phoneNumber
    if (!fieldsUserUpdate["mobNo"] || fieldsUserUpdate["mobNo"] === "") {
      formIsValid = false;
      errorsUserUpdate["mobNo"] = "Cannot be empty";
    }

    // console.log("errorsUpdateQuoteerrorsUpdateQuoteerrorsUpdateQuote", errorsUserUpdate);
    this.setState({ errorsUserUpdate: errorsUserUpdate });
    return formIsValid;
  }


  handleValidationUpdateUserPassword = () => {
    let fieldsUserPasswordUpdate = this.state.fieldsUserPasswordUpdate;
    let errorsUpdatePassword = {};
    let formIsValid = true;

    //newpassword
    if (!fieldsUserPasswordUpdate["newpassword"] || fieldsUserPasswordUpdate["newpassword"] === "") {
      formIsValid = false;
      errorsUpdatePassword["newpassword"] = "Cannot be empty";
    }

    //newpassword
    if (!fieldsUserPasswordUpdate["confirmnewpassword"] || fieldsUserPasswordUpdate["confirmnewpassword"] === "") {
      formIsValid = false;
      errorsUpdatePassword["confirmnewpassword"] = "Cannot be empty";
    }

    this.setState({ errorsUpdatePassword: errorsUpdatePassword });
    return formIsValid;
  }

  handleAddUserModalOpen = () => {
    this.setState({ addUserModal: true, })
  }

  handleOpenUpdateUserModal = (data) => {
    console.log('data........', data);
    this.setState({ UpdateUserModal: true, fieldsUserUpdate: data, updateSelectedCategory: data.categoryList });
  }

  handlePasswordModal = (data) => {
    this.setState({ creditpasswordOpenModal: true, fieldsUserPasswordUpdate: data })
    console.log("datadatadatadata", data);
  }
  handleCreditpasswordHideModal = () => {
    this.state.fieldsUserPasswordUpdate.confirmPassword = ''
    this.state.fieldsUserPasswordUpdate.password = ''
    this.setState({ creditpasswordOpenModal: false, })
  }
  handleAddUserModalClose = () => {
    this.setState({ addUserModal: false, fieldsUser: {}, errorsUser: {} })
  }

  handleUpdatePasswordHideModalAdd = () => {
    this.setState({ AddBalanceModal: false, balance: '' });
  }
  handleUpdateHideModal = () => {
    this.setState({ DeductBalanceModal: false, balance: '' });
  }
  handleOpenCreateModalUpdatePasswordAddBal = (data) => {
    this.setState({ idParam: data && data.id });
    this.setState({ AddBalanceModal: true, fieldsUserUpdate: { id: this.props.match.params.id } });


    // console.log("11111111111", data && data.id);
  }
  handleOpenAddSession = (data) => {
    this.setState({ idParam: data && data.id });
    this.setState({ AddPtSessionModel: true, });


    // console.log("11111111111", data && data.id);
  }
  handleCloseAddSession = (data) => {
    this.setState({ AddPtSessionModel: false });


    // console.log("11111111111", data && data.id);
  }
  handleOpenCreateModalPassword = (data) => {
    this.setState({ DeductBalanceModal: true, fieldsUserdeduct: data.id });
  }

  handleValidationUpdateUserAdd = () => {
    let balance = this.state.balance;
    let errorsUpdateQuoteAdd = {};
    let formIsValid = true;

    //name
    if (!balance || balance === "") {
      formIsValid = false;
      errorsUpdateQuoteAdd["balance"] = "Cannot be empty";
    }

    this.setState({ errorsUpdateQuoteAdd: errorsUpdateQuoteAdd });
    return formIsValid;
  }

  setBalance = (e) => {
    e.preventDefault();
    let value = e.target.value;
    // // console.log('value__________', value);
    this.setState({ balance: value })
  }

  handleHover() {
    this.setState(prevState => ({ hover: !prevState.hover }));
  }

  handleGoBack = () => {
    this.props.history.goBack();
  };

  render() {

    let { users } = this.props;
    let { filesDetails, getUserListItems, total, loading } = users;
    const { hover, scale } = this.state;

    return (

      <>
        <div>
          <LoadingOverlay
            active={loading}
            className="temp001"
            spinner
            text='Please wait...' />
        </div>

        <div className="flex flex-col flex-1 overflow-hidden overflow-x-auto overflow-y-auto">
          <main className="relative flex-1 ">
            <div className="p-3 2xl:p-10 sm:p-5">
              <div className="mx-auto max-w-screen-3xl">
                {/* Transaction Section */}
                <section className="p-6 space-y-6 bg-white border rounded-md">

                  <div className="flex flex-wrap items-center justify-between w-full ">
                    <div className="flex space-x-6">
                      <div onClick={this.handleGoBack} className='p-1 text-gray-600 border border-gray-400 rounded-full cursor-pointer hover:bg-blue-400 hover:border-blue-400 hover:text-white'><BiArrowBack className='w-6 h-6' /></div>
                      <h3 className="font-medium text-xl text-[#3D405B] whitespace-nowrap pt-1">Active User list</h3>
                    </div>

                    <div className='flex space-x-6 '>
                      <form action="#" method="GET"  >
                        <label htmlFor="mobNo-search" className="sr-only">Search</label>
                        <div className="relative">
                          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                            <BiSearch style={{ fontSize: '1.5rem' }} className="text-gray-500" />
                          </div>
                          <input type="text" name="email" id="mobNo-search" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg  focus:ring-cyan-600 block w-full pl-10 p-2.5" placeholder="Search" onChange={this.handleSearch} required />
                        </div>
                      </form>
                      <button className="flex items-center px-6 py-2 text-sm font-medium text-white capitalize bg-blue-500 rounded-md" onClick={() => this.handleAddUserModalOpen()}><MdAdd style={{ fontSize: "1.5rem" }} className="mr-1.5" /> Add User </button>
                    </div>
                  </div>



                  <div className="pb-2 mt-4 overflow-hidden overflow-x-auto rounded-lg shadow-md">
                    <div className="max-w-full">
                      <div className="inline-block min-w-full ">
                        <div className="">
                          <table className="min-w-full border-0 divide-y ">
                            <thead className="bg-gray-200 rounded-t">
                              <tr className="text-sm font-semibold text-left text-gray-500 uppercase">
                                <th className="px-6 py-3 whitespace-nowrap">#</th>
                                <th className="px-6 py-3 whitespace-nowrap">Name</th>
                                <th className="px-6 py-3 whitespace-nowrap">UserName</th>
                                <th className="px-6 py-3 whitespace-nowrap">Email</th>
                                <th className="px-6 py-3 whitespace-nowrap">Mobile Number</th>
                                {/* <th className="px-6 py-3 text-center whitespace-nowrap">image</th> */}
                                <th className="px-6 py-3 text-center whitespace-nowrap">Status</th>
                                <th className="px-6 py-3 text-center whitespace-nowrap">Actions</th>
                              </tr>
                            </thead>

                            <tbody>
                              {getUserListItems && getUserListItems.length > 0 ?
                                getUserListItems.map((element, index) => (<React.Fragment key={element.id}>
                                  <tr key={element.id} className="bg-white border-b border-black border-opacity-10 ">
                                    <td className="px-6 py-3 text-sm font-medium text-gray-600 whitespace-nowrap">
                                      {this.state.offset + index + 1}</td>
                                    <td className="px-6 py-3 text-sm font-medium text-gray-800 capitalize whitespace-nowrap">
                                      {element && element.name ? element.name : "NA"}</td>
                                    <td className="px-6 py-3 text-sm font-medium text-gray-800 capitalize whitespace-nowrap">
                                      {element && element.userName ? element.userName : "NA"}</td>
                                    <td className="px-6 py-3 text-sm text-gray-600 whitespace-nowrap">
                                      {element && element.email ? element.email : "NA"}</td>
                                    <td className="px-6 py-3 text-sm text-gray-600 whitespace-nowrap">
                                      {element && element.mobNo ? element.mobNo : "NA"}</td>
                                    {/* <td className="px-6 py-3 text-sm text-gray-600 whitespace-nowrap">
                                      <div className='flex justify-center' onMouseEnter={this.handleHover} onMouseLeave={this.handleHover} style={{ position: 'relative' }}>
                                        <img className="object-cover h-10 rounded-sm w-14" src={element && element.imageLinkUrl ? element.imageLinkUrl : "/dist/img/profile.png"} style={{ transform: `scale(${hover ? 1.5 : 1 * scale})`, transition: 'transform 0.2s ease-out' }} alt="" />
                                      </div>
                                    </td> */}

                                    <td className="px-2 py-3 text-sm text-gray-600 whitespace-nowrap">
                                      <span className="flex justify-center pl-1">
                                        {element.isDisabled === false ?
                                          <div class="targetablepx-4 tooltip px-3 py-1 font-medium tracking-wider text-blue-100 bg-green-700 border rounded-md shadow-sm hover:shadow-lg hover:bg-green-400 cursor-pointer" onClick={() => this.disableUser(element)}>
                                            <label>Enable</label>
                                          </div>
                                          : <div class="targetablepx-4 tooltip px-3 py-1 font-medium tracking-wider text-blue-100 bg-red-500 border rounded-md shadow-sm hover:shadow-lg hover:bg-green-400 cursor-pointer" onClick={() => this.disableUser(element)}>
                                            <label>Disabled</label>
                                          </div>}
                                      </span>
                                    </td>
                                    <td className="flex justify-center px-2 py-3 space-x-2 text-center text-gray-600 whitespace-nowrap">
                                      <div className='flex space-x-2'>
                                        {/* <span className="relative ">
                                          {element.isActive ? "ADDED" : <div class="targetablepx-4 tooltip p-2 rounded-full font-medium hover:bg-blue-100 cursor-pointer  " onClick={() => this.handleOpenCreateModalMoreDetails(element)}>
                                            <span className='top-0 left-0 p-6 mx-auto -mt-8 text-sm text-white bg-gray-500 rounded tooltip-text'>More Details</span>
                                            <BiDetail style={{ fontSize: "1.5rem" }} />
                                          </div>}
                                        </span> */}
                                        <span className="relative">
                                          <div class="targetablepx-4 tooltip p-2 rounded-full font-medium hover:bg-blue-100 cursor-pointer" onClick={() => this.handleOpenUpdateUserModal(element)}>
                                            <span className='top-0 left-0 p-6 mx-auto -mt-8 text-sm text-white bg-gray-500 rounded tooltip-text'>Edit</span>
                                            <MdOutlineEdit style={{ fontSize: "1.5rem" }} />
                                          </div>
                                        </span>
                                        <span className="relative ">
                                          {element.isActive ? "ADDED" : <div class="targetablepx-4 tooltip p-2 rounded-full font-medium hover:bg-blue-100 cursor-pointer  " onClick={() => this.handlePasswordModal(element)}>
                                            <span className='top-0 left-0 p-6 mx-auto -mt-8 text-sm text-white bg-gray-500 rounded tooltip-text'>Password</span>
                                            <RiLockPasswordLine style={{ fontSize: "1.5rem" }} />
                                          </div>}
                                        </span>
                                      </div>
                                    </td>
                                  </tr>
                                </React.Fragment>))
                                : (<tr className="bg-white bg-opacity-5 " >
                                  <td className="col-span-3 px-6 py-3 text-sm font-medium text-gray-500 whitespace-nowrap">Not Found</td>
                                </tr>)}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    {/* Table Pagination Section */}
                    {
                      isMobile ?
                        <nav className="relative z-0 flex justify-end mt-5 w-76">
                          {
                            total && total > 10 ?
                              <ReactPaginate
                                previousLabel={'Prev'}
                                nextLabel={'Next'}
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={total / this.state.size}
                                marginPagesDisplayed={1}
                                pageRangeDisplayed={1}
                                onPageChange={this.handlePageClick}
                                containerClassName={'pagination'}
                                pageClassName={'page-cls'}
                                activeClassName={'active'}
                              />
                              : null}
                        </nav> : <nav className="relative z-0 flex justify-end mt-5 w-76">
                          {
                            total && total > 10 ?
                              <ReactPaginate
                                previousLabel={'Previous'}
                                nextLabel={'Next'}
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={total / this.state.size}
                                marginPagesDisplayed={3}
                                pageRangeDisplayed={3}
                                onPageChange={this.handlePageClick}
                                containerClassName={'pagination'}
                                pageClassName={'page-cls'}
                                activeClassName={'active'}
                              />
                              : null}
                        </nav>
                    }
                  </div>
                </section>
              </div>
            </div>
          </main>
        </div>

        <DialogExample />

        <AddUserModal
          handleAddUserModalClose={this.handleAddUserModalClose}
          addUserModal={this.state.addUserModal}
          fieldsUser={this.state.fieldsUser}
          errorsUser={this.state.errorsUser}
          inputAddUserChange={this.inputAddUserChange}
          createAddUserSubmit={this.createAddUserSubmit}
        />

        <UpdateUserModal
          UpdateUserModal={this.state.UpdateUserModal}
          fieldsUserUpdate={this.state.fieldsUserUpdate}
          errorsUserUpdate={this.state.errorsUserUpdate}
          inputChangeUpdateUser={this.inputChangeUpdateUser}
          updateUserSubmit={this.updateUserSubmit}
          handleUpdateUserModalClose={this.handleUpdateUserModalClose}
        />

        <ViewMoreDetailsModal
          moreDetailsCreateModal={this.state.moreDetailsCreateModal}
          userRowData={this.state.userRowData}
          handleMoreDetailsHideModal={this.handleMoreDetailsHideModal}
          filesDetails={filesDetails}
        />

        <UpdateUserPasswordModal
          creditpasswordOpenModal={this.state.creditpasswordOpenModal}
          fieldsUserPasswordUpdate={this.state.fieldsUserPasswordUpdate}
          errorsUpdatePassword={this.state.errorsUpdatePassword}
          inputChangeUpdatePasswordUser={this.inputChangeUpdatePasswordUser}
          updateUserPasswordSubmit={this.updateUserPasswordSubmit}
          handleCreditpasswordHideModal={this.handleCreditpasswordHideModal}
        />
      </>

    );
  }
}
function mapStateToProps(state) {
  const { users, membership, banner, trainer } = state;
  return {
    users, membership, banner, trainer
  };
}
export default connect(mapStateToProps)(User);
